import { AueTimeFrame, DeviceLastActiveTimeframe } from '@cdw-ae/common-data';
import { VersionInfo } from '../../../../components/charts/models/chart.model';

export interface DashboardGridConfig {
  smallColumns: number;
  mediumColumns: number;
  largeColumns: number;
  gap: string; // Tailwind gap class
}

// Default grid configuration
export const DEFAULT_GRID_CONFIG: DashboardGridConfig = {
  smallColumns: 1,
  mediumColumns: 2,
  largeColumns: 4, // maximum
  gap: 'gap-6',
};

export enum CardSize {
  SMALL = 'small',
  LARGE = 'large',
}

export interface DevicesBatteryHealthSummary {
  poorBatteryHealth: number;
  storageMoreThan80Full: number;
  moreThan3OsVersionsBehind: number;
  autInNext90Days: number;
}

export interface DevicesVersionSummary {
  [VersionInfo.LATEST_OS]: number;
  [VersionInfo.ONE_OS_BEHIND]: number;
  [VersionInfo.TWO_OS_BEHIND]: number;
  [VersionInfo.THREE_PLUS_OS_BEHIND]: number;
}

export interface DevicesLastActiveSummary {
  [DeviceLastActiveTimeframe.NotActive]: number;
  [DeviceLastActiveTimeframe.SevenDays]: number;
  [DeviceLastActiveTimeframe.FourteenDays]: number;
  [DeviceLastActiveTimeframe.ThirtyDays]: number;
  [DeviceLastActiveTimeframe.Unknown]: number;
}

export interface DevicesAutoUpdateExpirySummary {
  [AueTimeFrame.PastAUE]: number;
  [AueTimeFrame.LessThan3Months]: number;
  [AueTimeFrame.LessThan6Months]: number;
  [AueTimeFrame.LessThan12Months]: number;
  [AueTimeFrame.GreaterThan12Months]: number;
  [AueTimeFrame.Unknown]: number;
}

export enum CardType {
  DEVICE_LAST_ACTIVE_CARD = 'device-last-active-card',
  POOR_BATTERY_HEALTH_CARD = 'poor-battery-health-card',
  AUTO_UPDATE_EXPIRY_CARD = 'auto-update-expiry-card',
  STORAGE_USAGE_OVER_80_CARD = 'storage-usage-over-80-card',
  OS_VERSION_OVER_3_BEHIND_CARD = 'os-version-over-3-behind-card',
  AUE_IN_90_DAYS_CARD = 'aue-in-90-days-card',
  DEVICE_OS_VERSION_STATUS_CARD = 'device-overview-card',
  SINGLE_USER_REPORT_CARD = 'single_user_report_card',
  SINGLE_DEVICE_REPORT_CARD = 'single_device_report_card',
  AGGREGATE_REPORTS_CARD = 'aggregate_reports_card',
}

export interface DashboardSummaries {
  batteryHealthSummary: DevicesBatteryHealthSummary | null;
  deviceVersionSummary: DevicesVersionSummary | null;
  deviceLastActiveSummary: DevicesLastActiveSummary | null;
  deviceAueSummary: DevicesAutoUpdateExpirySummary | null;
}
